module.exports = __webpack_public_path__ + "img/themes.1b56a835.svg";